import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { useHeaderV3 } from './HeaderV3.logic';
import { View } from 'react-native';
import { styleDesktop as style } from './HeaderV3.style';
import { MainLogoPressable } from '@photosi/rn-components/main-logo-pressable/MainLogoPressable';
import { headerEditorTestID } from 'src/helpers/testIDs.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import { FocusGroups } from '../../focus-provider/FocusProvider.constants';
import { PhotoSlotButton } from 'src/editor-v3/components/photo-slot-button/PhotoSlotButton';
import { ProjectSaveButton } from '@photosi/rn-components/project/project-save-button/ProjectSaveButton';
import { TotalProductsSummary } from './total-products-summary/TotalProductsSummary';
import { PrimaryButton } from 'src/editor-v3/components/buttons/primary-button/PrimaryButton';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { BaseHoverTooltip } from '@photosi/rn-components/tooltips/base-hover-tooltip/BaseHoverTooltip';
import { TooltipPosition } from '../../tooltips/Tooltip.types';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';

export const HeaderDesktopV3 = observer(() => {
  const { i18n, project } = useStore();
  const { isNoProducts, estimatePrice, originalPrice, handleClickAddToCart, totalNumberOfProducts } = useHeaderV3();
  const { isSmallDesktop } = useResponsiveScreen();

  const isButtonDisabled =
    (!project.isProjectAddedToCart && (isNoProducts || project.isAddToCartDisabled)) || project?.isUploading;

  const DisabledCartTooltipContent = () => {
    return (
      <View style={{ paddingHorizontal: 12, paddingVertical: 6 }}>
        <TextLato style={style.hoverText}>{i18n.t('header:uploading')}</TextLato>
      </View>
    );
  };

  return (
    <View style={style.headerContainer} accessibilityRole="toolbar">
      <View style={style.leftElements}>
        <View style={style.leftActions}>
          <MainLogoPressable
            testID={TestIDs.PHOTOSI_LOGO}
            focusId={TestIDs.PHOTOSI_LOGO}
            focusOrder={0}
            focusGroup={FocusGroups.HEADER}
          />
          <View style={style.separator} />
        </View>
        {!project.isProjectAddedToCart && (
          <PhotoSlotButton
            focusId={headerEditorTestID(TestIDs.PHOTO_DRAWER, 'button')}
            focusOrder={1}
            focusGroup={FocusGroups.HEADER}
          />
        )}
      </View>
      <View style={[style.rightElements, isSmallDesktop && { flexGrow: 2 }]}>
        <ProjectSaveButton isPressTooltipEnabled={true} focusOrder={2} focusGroup={FocusGroups.HEADER} />
        <View style={style.separator} />
        <View style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}>
          <TotalProductsSummary
            totalNumberOfProducts={totalNumberOfProducts}
            originalPrice={originalPrice}
            estimatePrice={estimatePrice}
            focusId={headerEditorTestID(TestIDs.TOTAL_PRODUCTS)}
            focusOrder={3}
          />
          <BaseHoverTooltip
            TooltipContent={project?.isUploading ? DisabledCartTooltipContent : undefined}
            position={TooltipPosition.BOTTOM}
          >
            <PrimaryButton
              style={style.buttonCart}
              innerStyle={{}}
              onPress={handleClickAddToCart}
              disabled={isButtonDisabled}
              testID={headerEditorTestID(TestIDs.ADD_TO_CART)}
              focusGroup={FocusGroups.HEADER}
              focusOrder={4}
              focusId={headerEditorTestID(TestIDs.ADD_TO_CART)}
              text={i18n.t(project.isProjectAddedToCart ? 'header:confirm' : 'header:go-to-cart')}
              accessibilityLabel={i18n.t(project.isProjectAddedToCart ? 'header:confirm' : 'header:go-to-cart')}
            />
          </BaseHoverTooltip>
        </View>
      </View>
    </View>
  );
});
